import * as React from 'react';
import Svg, {
  SvgProps,
  Path,
  Defs,
  LinearGradient,
  Stop,
} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={103}
    height={28}
    viewBox={'0 0 103 28'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <Path
      fill="url(#a)"
      fillOpacity={0.85}
      d="M51.5 28C79.943 28 103 15.464 103 0H0c0 15.464 23.057 28 51.5 28Z"
    />
    <Path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={2}
      d="m64.065 9-11.392 7.283a2 2 0 0 1-2.216-.04L40 9"
    />
    <Defs>
      <LinearGradient
        id="a"
        x1={48.027}
        x2={48.027}
        y1={0}
        y2={28}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#009F9C" />
        <Stop offset={1} stopColor="#007BB2" />
      </LinearGradient>
    </Defs>
  </Svg>
);
export default SvgComponent;
